// HowItWorks.js
import React from "react";
import "../scss/howItWorks.css";
import video from "../images/Rider Demo Video.mp4";

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <h2 style={{ marginTop: "40px !important" }}>How It Works ?</h2>
      <div className="content">
        <iframe
          src={video} // replace with your actual mp4 path
          controls
        ></iframe>

        <p
          style={{
            fontSize: "clamp(30px, 8vw, 70px)", // min 30px, scales with viewport, max 70px
            color: "#0d0d0eff",
            margin: 0, // optional: remove default margin
          }}
        >
          |
        </p>

        <a href="/mannual" className="pdf-link">
          Read this steps
        </a>
      </div>
    </section>
  );
};

export default HowItWorks;
